export const ACTION_PREFIX_HISTORY = 'history'